import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export interface AssignmentDto {
  id?: number;
  name?: string;
  areaId?: number;
  areaCode?: string;
  areaName?: string;
  sortOrder?: number;
  isActive?: boolean;
  requiresActiveMinistry?: boolean;
  allowedOrganizationLevelIds?: number[];
  allowedOrganizationLevelNames?: string[];
}

export interface CreateAssignmentDto {
  name: string;
  areaId: number;
  sortOrder?: number;
  requiresActiveMinistry?: boolean;
  allowedOrganizationLevelIds?: number[];
}

export interface UpdateAssignmentDto {
  name: string;
  areaId: number;
  sortOrder: number;
  isActive: boolean;
  requiresActiveMinistry?: boolean;
  allowedOrganizationLevelIds?: number[];
}

@Injectable({ providedIn: 'root' })
export class AssignmentManagementService {
  private readonly apiUrl = `${environment.apiUrl}/assignments`;

  constructor(private readonly http: HttpClient) {}

  getAll(): Observable<AssignmentDto[]> {
    return this.http.get<AssignmentDto[]>(this.apiUrl);
  }

  getById(id: number): Observable<AssignmentDto> {
    return this.http.get<AssignmentDto>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateAssignmentDto): Observable<AssignmentDto> {
    return this.http.post<AssignmentDto>(this.apiUrl, dto);
  }

  update(id: number, dto: UpdateAssignmentDto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateSortOrder(id: number, sortOrder: number): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/sort-order`, { sortOrder });
  }
}
